// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.fc .fc-daygrid-event-harness .fc-event[data-v-3a3b9bca] {\r\n    font-size: 1.06rem;\n}\r\n", ""]);
// Exports
module.exports = exports;
